import BulkEntry from './BulkEntry.js';

export default BulkEntry;
